function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import GLOBALS from '../../styles/defaultGlobals';
var BREAKPOINTS = GLOBALS.get('breakpoints');
var RESTRICTED_BREAKPOINTS = GLOBALS.get('restrictedBreakpoints');
var COLUMNS = GLOBALS.getIn(['sizes', 'columns']);
var TYPE_COLUMN = 'Column';
var TYPE_PUSH = 'Push';
var toObj = function toObj(input) {
  return input.reduce(function (acc, item) {
    return _objectSpread({}, acc, item);
  }, {});
};
var createMixin = function createMixin(name) {
  var columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : COLUMNS;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TYPE_COLUMN;
  return Array.from(Array(columns)).map(function (_, i) {
    var TYPE = type;
    var TYPE_PROP = type === TYPE_COLUMN ? 'width' : 'marginLeft';
    var COLUMN = i + 1;
    var NAME = "".concat(name.toLowerCase(), "-").concat(COLUMN);
    var SIZE = "".concat(COLUMN / columns * 100, "%");
    return _defineProperty({}, "".concat(TYPE, "-").concat(NAME), _defineProperty({}, TYPE_PROP, SIZE));
  });
};
var GRID = BREAKPOINTS.map(function (ITEM) {
  var QUERY = ITEM.get('query');
  var NAME = ITEM.get('name');
  return _defineProperty({}, QUERY, toObj(createMixin(NAME, COLUMNS, TYPE_COLUMN)));
});
var PUSH = RESTRICTED_BREAKPOINTS.map(function (ITEM) {
  var QUERY = ITEM.get('query');
  var NAME = ITEM.get('name');
  return _defineProperty({}, QUERY, toObj(createMixin(NAME, COLUMNS, TYPE_PUSH)));
});
export default _objectSpread({}, toObj(GRID), toObj(PUSH));